/* Define the routes */
const { PUBLIC_URL } = process.env;

export const BEFORE_LOGOUT_URL = 'before_logout_url';

export const ROOT = PUBLIC_URL + '/' || '/';
export const LOGIN = `${ ROOT }login/`;
export const REDIRECT = `${ ROOT }redirect`;
export const LOGOUT_REDIRECT = `${ ROOT }logout/redirect`;
